import CommonLayout from "../layouts/CommonLayout";
import BloodBankDashboard from "../layouts/BloodBank/BloodBankDashboard";
import BloodGroups from "../layouts/BloodBank/BloodGroups";
import BloodBankProfileSettings from "../layouts/BloodBank/BloodBankProfileSettings";
import BloodDonors from "../layouts/BloodBank/BloodDonors";
import BloodRequests from "../layouts/BloodBank/BloodRequests";
import BloodBankReports from "../layouts/BloodBank/BloodBankReports";
import BloodBankNotifications from "../layouts/BloodBank/BloodBankNotifications";
import AdminProtectedRoute from "../ProtectedRoute";

const bloodBankRoutes = [
    { path: "/blood-bank/dashboard", element: <AdminProtectedRoute><CommonLayout><BloodBankDashboard /></CommonLayout></AdminProtectedRoute> },
    { path: "/blood-bank/blood-groups", element: <AdminProtectedRoute><CommonLayout><BloodGroups /></CommonLayout></AdminProtectedRoute> },
    { path: "/blood-bank/donors", element: <AdminProtectedRoute><CommonLayout><BloodDonors /></CommonLayout></AdminProtectedRoute> },
    { path: "/blood-bank/requests", element: <AdminProtectedRoute><CommonLayout><BloodRequests /></CommonLayout></AdminProtectedRoute> },
    { path: "/blood-bank/reports", element: <AdminProtectedRoute><CommonLayout><BloodBankReports /></CommonLayout></AdminProtectedRoute> },
    { path: "/blood-bank/notifications", element: <AdminProtectedRoute><CommonLayout><BloodBankNotifications /></CommonLayout></AdminProtectedRoute> },
    { path: "/blood-bank/profile", element: <AdminProtectedRoute><CommonLayout><BloodBankProfileSettings /></CommonLayout></AdminProtectedRoute> },
];

export default bloodBankRoutes;

